module.exports = __webpack_public_path__ + "img/trivelli-Pasta-with-eggplant.1666c22e.jpg";